export const environment = {
    production: false,
    clientName:"BJS",
    siteUrl:"https://dev-lepratextbook.rivervalleytechnologies.in/",
    apiUrl: "https://dev-lepratextbook.rivervalleytechnologies.in/admin/backend/",
    applicationMode:"Staging",
    showAppMode:true,
};
